import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Search, Building2 } from "lucide-react";

export default function AdminCompanies() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/companies/").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  const f = items.filter(c => !q || (c.company_name || "").toLowerCase().includes(q.toLowerCase()) || (c.sector || "").toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Aziende</h1>
      <p className="text-sm text-slate-600 mb-4">Anagrafica aziende registrate.</p>
      <div className="mb-4 relative max-w-md"><Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><Input className="pl-9" placeholder="Cerca azienda, settore..." value={q} onChange={e => setQ(e.target.value)} /></div>
      <div className="cxo-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="p-3 text-left">Azienda</th><th className="p-3 text-left">Settore</th><th className="p-3 text-left">Sede</th><th className="p-3 text-left">Dipendenti</th><th className="p-3 text-left">Tipo</th><th className="p-3 text-left">Referente</th></tr>
          </thead>
          <tbody>
            {f.map(c => (
              <tr key={c.id} className="border-t border-slate-100">
                <td className="p-3 font-semibold text-slate-900 flex items-center gap-2"><Building2 size={16} className="text-slate-400" />{c.company_name}</td>
                <td className="p-3 text-slate-600">{c.sector}</td>
                <td className="p-3 text-slate-600">{c.city}, {c.region}</td>
                <td className="p-3 cxo-tabular">{c.size_employees}</td>
                <td className="p-3 flex gap-1">{c.is_family_business && <Badge variant="outline" className="text-[10px]">Familiare</Badge>}{c.is_startup && <Badge variant="outline" className="text-[10px]">Startup</Badge>}{c.is_scaleup && <Badge variant="outline" className="text-[10px]">Scale-up</Badge>}</td>
                <td className="p-3 text-slate-600">{c.user?.full_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
